import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance/axiosInstance";
import { ManagedMilestone } from "./ManagedMilestone";

export const fetchManagedMilestones = createAsyncThunk(
  "milestoneManagement/fetchManagedMilestones",
  async (projectId: number | undefined, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<ManagedMilestone[]>(
        "/milestones/managed",
        { params: projectId ? { projectId } : undefined }
      );
      return response.data;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

export const renameMilestone = createAsyncThunk(
  "milestoneManagement/renameMilestone",
  async (
    { milestoneId, name }: { milestoneId: number; name: string },
    { rejectWithValue }
  ) => {
    try {
      await axiosInstance.put(`/milestones/${milestoneId}/name`, { name });
      return { milestoneId, name };
    } catch (error: any) {
      if (error?.response?.status === 409) {
        return rejectWithValue(
          "A milestone with this name already exists in the project."
        );
      }
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

export const deleteMilestone = createAsyncThunk(
  "milestoneManagement/deleteMilestone",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/milestones/${milestoneId}`);
      return milestoneId;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);
